import {
  SET_BULK_TRANSACTIONS,
  RESET_BULK_TRANSACTIONS,
  SET_BULK_TRANSACTIONS_STATUS,
} from '@redux/actions/actionTypes'

const initialState = {
  isSuccessful: false,
  transactions: [],
}

const bulkTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BULK_TRANSACTIONS:
      return {
        ...state,
        // Loading a new set of transactions (e.g. a fresh file upload) starts a
        // new operation, so clear the previous success flag. Otherwise the Save
        // Changes button stays disabled after a completed run and blocks the
        // new upload.
        isSuccessful: false,
        transactions: action.payload,
      }
    case RESET_BULK_TRANSACTIONS:
      return {
        ...state,
        isSuccessful: false,
        transactions: [],
      }
    case SET_BULK_TRANSACTIONS_STATUS:
      return {
        ...state,
        isSuccessful: action.payload,
      }
    default:
      return state
  }
}

export default bulkTransactionReducer
